import styled from 'styled-components';

export const InfiniteScrollContainer = styled.div`
  flex: 1 1 auto;
  & .ReactVirtualized__Grid {
    outline: none;
  }
`;
